<mat-form-field style="width: 100%" [attr.data-cy]="'ceses_mat-form-field_1_8_'">
    <mat-label [attr.data-cy]="'ceses_mat-label_1_9_'">Einheit</mat-label>
    <mat-select
        [formControl]="einheitCtrl"
        [compareWith]="einheitComparator"
        (selectionChange)="einheitChanged($event)"
        [attr.data-cy]="'ceses_mat-select_1_6_'"
    >
        <mat-option
            *ngFor="let e of einheiten; let i = index"
            [value]="e"
            [attr.data-cy]="'ceses_mat-option_1_7_' + i"
            >{{ e.bezeichnung }}</mat-option
        >
    </mat-select>
    <mat-icon
        *ngIf="info"
        matSuffix
        class="field-info"
        [matTooltip]="info"
        matTooltipPosition="above"
    >info</mat-icon>
</mat-form-field>
